<template>
  <div class="container">
    <my-header :curHeader="4"></my-header>
    <main>
      <div class="menus">
        <div
          v-for="(item, index) in menus"
          class="menus-item"
          :class="{'menus-item-check': index === curMenu}"
          @click="curMenu = index"
        >{{ item.title }}
        </div>
      </div>
      <div class="list-container" v-loading="loading">
        <div class="container-main">
          <div v-for="(item, index) in list" @click="toDetail(item)">
            <img :src="$assetsPath+item.imgUrl"/>
            <p>{{ item.title }}</p>
            <p>{{ item.store }}</p>
            <div>联系我们</div>
          </div>
        </div>


        <!--        <div-->
        <!--          v-for="(item, index) in list"-->
        <!--          class="list-item"-->
        <!--          @click="toDetail(item)">-->
        <!--          <div class="list-item-title">{{ item.title }}</div>-->
        <!--          <div class="list-item-time">{{ item.publishTime }}</div>-->
        <!--        </div>-->

        <pagination
          v-if="list.length > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"/>
        <div v-else class="list-null">没有更多数据了</div>
      </div>
    </main>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHeader from '@/components/Header'
import MyFooter from '@/components/Footer'
import { scrollTo } from '@/utils/scrollTo'
import { getListProductDetail, getListIndustry } from '../../api'
import Pagination from '@/components/Pagination'

export default {
  components: {
    MyHeader,
    MyFooter,
    Pagination
  },
  data() {
    return {
      loading: true,
      curMenu: 0,
      menus: [],
      list: [],
      total: '0',
      queryParams: {
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  watch: {
    curMenu() {
      scrollTo(0, 500)
      this.getList()
    }
  },
  mounted() {
    getListIndustry().then(res => {
      this.menus = res.data
      this.getList()
    })
  },
  methods: {
    toDetail(obj) {
      this.$setCurArticle(obj)
      this.$router.push('/news-detail')
    },
    getList() {
      this.loading = true
      this.queryParams.industryId =  this.menus[this.curMenu].id
      getListProductDetail(this.queryParams).then(res => {
        this.list = res.rows
        this.total = parseInt(res.total)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  main {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .menus {
      width: 190px;
      position: sticky;
      top: 0;

      .menus-item {
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #1C4281;
        background: #fff;
        margin-bottom: 2px;
        cursor: pointer;
        transition: all 300ms;
      }

      .menus-item-check {
        color: #fff;
        background: #1279EC;
      }
    }

    .list-container {
      width: 1000px;
      min-height: 500px;

      .list-item {
        height: 70px;
        padding: 0 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        cursor: pointer;
        transition: all 300ms;
        background: #fff;
        margin-bottom: 10px;

        .list-item-title {
          color: #484E54;
        }

        .list-item-time {
          color: #8F98A0;
        }
      }

      .list-item:hover {
        background: #1279EC;

        .list-item-title, .list-item-time {
          color: #fff;
        }
      }

      .list-null {
        margin-top: 30px;
        text-align: center;
        color: #999;
        font-size: 14px;
      }
    }

    .container-main {
      display: flex;
      flex-wrap: wrap;

      & > div {
        //background-color: #1C4281;
        margin-right: 10px;
        margin-bottom: 10px;
        height: 300px;
        width: 24%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          height: 200px;
          width: 100%;
        }

        p {
          margin: 0 12px;
        }

        div:last-child {
          height: 30px;
          width: 100%;
          text-align: center;
          line-height: 30px;
          color: #ec6c12;
          border: 1px solid #ec6c12;
          cursor: pointer;

          &:hover {
            background-color: #ec6c12;
            border: 1px solid #ec6c12;
            color: white;
          }
        }
      }

      &:nth-child(4) {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue